var R = Object.defineProperty;
var N = (e, t, s) => t in e ? R(e, t, { enumerable: !0, configurable: !0, writable: !0, value: s }) : e[t] = s;
var S = (e, t, s) => (N(e, typeof t != "symbol" ? t + "" : t, s), s);
import { createContext as q, useContext as B } from "react";
const J = q(void 0), se = () => {
  const e = B(J);
  if (e === void 0)
    throw new Error("CommunicationContext undefined");
  return e;
};
class _ extends Error {
  constructor(t, s) {
    super(s), this.actionHint = t;
  }
}
var h = /* @__PURE__ */ ((e) => (e[e.FileUpload = 1] = "FileUpload", e[e.FileRequest = 2] = "FileRequest", e[e.Remove = 5] = "Remove", e[e.Switch = 9] = "Switch", e[e.Event = 126] = "Event", e[e.SystemCall = 127] = "SystemCall", e[e.Execute = 8] = "Execute", e[e.Unknown = 0] = "Unknown", e))(h || {}), l = /* @__PURE__ */ ((e) => (e[e.LogLine = 0] = "LogLine", e[e.FilePreset = 1] = "FilePreset", e[e.FileConfig = 2] = "FileConfig", e[e.FileSnapshot = 3] = "FileSnapshot", e[e.PresetList = 4] = "PresetList", e[e.SnapshotList = 5] = "SnapshotList", e[e.SnapshotInfo = 6] = "SnapshotInfo", e[e.Control = 7] = "Control", e[e.PresetSlot = 8] = "PresetSlot", e[e.SnapshotSlot = 9] = "SnapshotSlot", e[e.Page = 10] = "Page", e[e.ControlSet = 11] = "ControlSet", e[e.FileLua = 12] = "FileLua", e[e.Function = 13] = "Function", e[e.Value = 14] = "Value", e[e.EventSubscription = 121] = "EventSubscription", e[e.FileUi = 112] = "FileUi", e[e.Window = 122] = "Window", e[e.ControlPort = 123] = "ControlPort", e[e.AppInfo = 124] = "AppInfo", e[e.Logger = 125] = "Logger", e[e.RuntimeInfo = 126] = "RuntimeInfo", e[e.ElectraInfo = 127] = "ElectraInfo", e[e.Unknown = 63] = "Unknown", e))(l || {}), P = /* @__PURE__ */ ((e) => (e[e.Nack = 0] = "Nack", e[e.Ack = 1] = "Ack", e[e.PresetSwitch = 2] = "PresetSwitch", e[e.SnapshotChange = 3] = "SnapshotChange", e[e.SnapshotBankSwitch = 4] = "SnapshotBankSwitch", e[e.PresetListChange = 5] = "PresetListChange", e[e.PageSwitch = 6] = "PageSwitch", e[e.ControlSetSwitch = 7] = "ControlSetSwitch", e[e.PresetBankSwitch = 8] = "PresetBankSwitch", e[e.UsbHostChange = 9] = "UsbHostChange", e[e.Unknown = 127] = "Unknown", e))(P || {});
const k = 240, D = 247, M = [0, 33, 69], $ = (e) => e.at(0) === k && e.at(-1) === D, H = (e) => $(e) && e.length >= M.length + 2 ? M.every(
  (t, s) => t === e[s + 1]
) : !1, V = (e) => e.subarray(1 + M.length, -1), F = async (e, t, s, r) => {
  let n;
  try {
    return await Promise.race([
      e,
      new Promise((a, o) => {
        n = setTimeout(
          () => o(
            new _(
              s,
              `Promise rejected after timeout of ${t} milliseconds`
            )
          ),
          t
        );
      })
    ]);
  } finally {
    clearTimeout(n), r == null || r();
  }
}, T = (e) => e !== void 0 && e >= 0 && e <= 2, Y = (e) => {
  if (!T(e))
    throw new Error(`Unexpected port number: ${e}`);
  switch (e) {
    case 0:
      return 1;
    case 1:
      return 2;
    case 2:
      return "ctrl";
  }
}, L = (e) => Uint8Array.from(e, (t) => {
  const s = t.charCodeAt(0);
  return s < 128 ? s : 33;
}), p = (e) => Uint8Array.from([
  k,
  ...M,
  ...e,
  D
]), G = () => p(
  Uint8Array.from([h.FileRequest, l.FilePreset])
), W = (e) => p(
  Uint8Array.from([
    h.FileUpload,
    l.FilePreset,
    ...e
  ])
), X = (e) => p(
  Uint8Array.from([h.FileUpload, l.FileLua, ...e])
), z = (e) => p(
  Uint8Array.from([
    h.FileUpload,
    l.FileConfig,
    ...e
  ])
), K = () => p(
  Uint8Array.from([h.FileRequest, l.PresetList])
), Q = (e, t) => p(
  Uint8Array.from([h.Switch, l.PresetSlot, e, t])
), Z = (e, t) => p(
  Uint8Array.from([h.Remove, l.FilePreset, e, t])
), b = (e) => p(
  Uint8Array.from([h.Execute, l.Function, ...e])
), O = {
  disabled: 0,
  critical: 0,
  warning: 1,
  info: 2,
  trace: 3
}, C = (e) => p(
  Uint8Array.from([
    h.SystemCall,
    l.Logger,
    e === "disabled" ? 0 : 1,
    O[e]
  ])
), m = (e) => {
  switch (e[0]) {
    case h.FileUpload: {
      switch (e[1]) {
        case l.FilePreset:
          return {
            type: "preset",
            preset: JSON.parse(
              String.fromCharCode(...e.subarray(2))
            )
          };
        case l.FileConfig:
          return {
            type: "configuration",
            configuration: JSON.parse(
              String.fromCharCode(...e.subarray(2))
            )
          };
        case l.PresetList: {
          const { presets: t } = JSON.parse(
            String.fromCharCode(...e.subarray(2))
          );
          return {
            type: "preset-list",
            presetList: t
          };
        }
        case l.ElectraInfo:
          return {
            type: "info",
            info: JSON.parse(
              String.fromCharCode(...e.subarray(2))
            )
          };
      }
      break;
    }
    case h.Event: {
      switch (e[1]) {
        case P.Ack:
          return {
            type: "ack"
          };
        case P.Nack:
          return {
            type: "nack"
          };
        case P.PresetSwitch:
          return {
            type: "preset-switch",
            bank: e[2],
            slot: e[3]
          };
        case P.PresetListChange:
          return {
            type: "preset-list-change"
          };
        case P.PresetBankSwitch:
          return {
            type: "preset-bank-switch",
            bank: e[2]
          };
      }
      break;
    }
    case h.SystemCall: {
      switch (e[1]) {
        case l.LogLine:
          return {
            type: "log",
            data: String.fromCharCode(...e.subarray(2))
          };
      }
      break;
    }
  }
  return {
    type: "unknown"
  };
}, j = (e) => {
  if (!H(e))
    return {
      type: "non-electra",
      rawData: e
    };
  const t = V(e);
  return {
    ...m(t),
    rawData: e
  };
}, v = (e) => Array.from(e).map(([, t]) => ({
  id: t.id,
  name: t.name ?? t.manufacturer ?? t.id
}));
class U extends Error {
}
class d {
  constructor() {
    S(this, "midiAccess");
    S(this, "portChangeListeners");
    S(this, "inputMessageListeners");
    S(this, "handleMidiInput", (t) => {
      const s = t, r = s.target, n = this.inputMessageListeners.get(r.id);
      if (n !== void 0 && s.data !== null) {
        const i = j(s.data);
        if (i.type === "unknown") {
          console.log("unknown message", r.name, i);
          return;
        }
        n.forEach(
          (a) => a({
            portId: r.id,
            message: i,
            timestamp: Date.now()
          })
        );
      }
    });
    this.portChangeListeners = /* @__PURE__ */ new Set(), this.inputMessageListeners = /* @__PURE__ */ new Map();
  }
  async ensurePermission() {
    this.midiAccess = await navigator.requestMIDIAccess({
      software: !1,
      sysex: !0
    }), this.midiAccess.onstatechange = () => {
      this.portChangeListeners.forEach((t) => t());
    };
  }
  removeListeners() {
    if (this.midiAccess === void 0)
      throw new Error("MIDI access undefined, call 'ensurePermission' first.");
    this.midiAccess.inputs.forEach(
      (t) => t.removeEventListener("midimessage", this.handleMidiInput)
    );
  }
  getInputPorts() {
    if (this.midiAccess === void 0)
      throw new Error("MIDI access undefined, call 'ensurePermission' first.");
    return v(this.midiAccess.inputs.entries());
  }
  getOutputPorts() {
    if (this.midiAccess === void 0)
      throw new Error("MIDI access undefined, call 'ensurePermission' first.");
    return v(this.midiAccess.outputs.entries());
  }
  addInputMessageListener(t, s) {
    this.inputMessageListeners.has(t) || this.inputMessageListeners.set(t, /* @__PURE__ */ new Set()), this.inputMessageListeners.get(t).add(s);
  }
  removeInputMessageListener(t, s) {
    this.inputMessageListeners.has(t) && this.inputMessageListeners.get(t).delete(s);
  }
  addPortChangeListener(t) {
    this.portChangeListeners.add(t);
  }
  removePortChangeListener(t) {
    this.portChangeListeners.delete(t);
  }
  async getElectraInfo(t, s, r) {
    const [n] = await Promise.all([
      this.waitForMessage(t, "info", r, {
        type: "get-electra-info",
        inputId: t,
        outputId: s
      }),
      this.sendData(
        s,
        p(
          Uint8Array.from([h.FileRequest, l.ElectraInfo])
        )
      )
    ]);
    return n.info;
  }
  async getElectraConfiguration(t, s, r) {
    const [n] = await Promise.all([
      this.waitForMessage(t, "configuration", r, {
        type: "get-electra-config",
        inputId: t,
        outputId: s
      }),
      this.sendData(
        s,
        p(
          Uint8Array.from([h.FileRequest, l.FileConfig])
        )
      )
    ]);
    return n.configuration;
  }
  async setElectraConfiguration(t, s, r, n) {
    const i = JSON.stringify(r), a = L(i), o = z(a);
    await Promise.all([
      this.waitForMessage(t, "ack", n, {
        type: "set-electra-config",
        inputId: t,
        outputId: s
      }),
      this.sendData(s, o)
    ]);
  }
  async openInput(t, s) {
    if (this.midiAccess === void 0)
      throw new Error("MIDI access undefined, call 'ensurePermission' first.");
    const r = this.midiAccess.inputs.get(t);
    if (r === void 0)
      throw new Error(`Unknown input with ID='${t}'`);
    r.connection !== "open" && (await F(r.open(), s, {
      type: "open-input-port",
      portId: t
    }), r.addEventListener("midimessage", this.handleMidiInput));
  }
  async closeInput(t, s) {
    if (this.midiAccess === void 0)
      throw new Error("MIDI access undefined, call 'ensurePermission' first.");
    const r = this.midiAccess.inputs.get(t);
    if (r === void 0)
      throw new Error(`Unknown input with ID='${t}'`);
    r.connection !== "closed" && (await F(r.close(), s, {
      type: "close-input-port",
      portId: t
    }), r.removeEventListener("midimessage", this.handleMidiInput));
  }
  async openOutput(t, s) {
    if (this.midiAccess === void 0)
      throw new Error("MIDI access undefined, call 'ensurePermission' first.");
    const r = this.midiAccess.outputs.get(t);
    if (r === void 0)
      throw new Error(`Unknown output with ID='${t}'`);
    r.connection !== "open" && await F(r.open(), s, {
      type: "open-output-port",
      portId: t
    });
  }
  async closeOutput(t, s) {
    if (this.midiAccess === void 0)
      throw new Error("MIDI access undefined, call 'ensurePermission' first.");
    const r = this.midiAccess.outputs.get(t);
    if (r === void 0)
      throw new Error(`Unknown output with ID='${t}'`);
    r.connection !== "closed" && await F(r.close(), s, {
      type: "close-output-port",
      portId: t
    });
  }
  sendData(t, s) {
    if (this.midiAccess === void 0)
      throw new Error("MIDI access undefined, call 'ensurePermission' first.");
    const r = this.midiAccess.outputs.get(t);
    if (r === void 0)
      throw new Error(`Unknown output with ID='${t}'`);
    return r.send(s), Promise.resolve();
  }
  async getPreset(t, s, r) {
    const n = G(), [i] = await Promise.all([
      this.waitForMessage(t, "preset", r, {
        type: "get-preset",
        inputId: t,
        outputId: s
      }),
      this.sendData(s, n)
    ]);
    return i.preset;
  }
  async sendPreset(t, s, r, n) {
    const i = JSON.stringify(r), a = L(i), o = W(a);
    await Promise.all([
      this.waitForMessage(t, "ack", n, {
        type: "send-preset",
        inputId: t,
        outputId: s
      }),
      this.sendData(s, o)
    ]);
  }
  async sendLua(t, s, r, n) {
    const i = L(r), a = X(i);
    await Promise.all([
      this.waitForMessage(t, "ack", n, {
        type: "send-lua",
        inputId: t,
        outputId: s
      }),
      this.sendData(s, a)
    ]);
  }
  async getPresetList(t, s, r) {
    const n = K(), [i] = await Promise.all([
      this.waitForMessage(t, "preset-list", r, {
        type: "get-preset-list",
        inputId: t,
        outputId: s
      }),
      this.sendData(s, n)
    ]);
    return i.presetList;
  }
  async switchToSlot(t, s, r, n, i) {
    const a = Q(r, n);
    await Promise.all([
      this.waitForMessage(t, "ack", i, {
        type: "switch-to-slot",
        inputId: t,
        outputId: s
      }),
      this.sendData(s, a)
    ]);
  }
  async clearSlot(t, s, r, n, i) {
    const a = Z(r, n);
    await Promise.all([
      this.waitForMessage(t, "ack", i, {
        type: "clear-slot",
        inputId: t,
        outputId: s
      }),
      this.sendData(s, a)
    ]);
  }
  async executeLua(t, s, r, n) {
    const i = L(r), a = b(i);
    await Promise.all([
      this.waitForMessage(t, "ack", n, {
        type: "execute-lua",
        inputId: t,
        outputId: s
      }),
      this.sendData(s, a)
    ]);
  }
  async setLogLevel(t, s, r, n) {
    const i = C(r);
    r === "disabled" ? await this.sendData(s, i) : await Promise.all([
      this.waitForMessage(t, "ack", n, {
        type: "set-log-level",
        inputId: t,
        outputId: s
      }),
      this.sendData(s, i)
    ]);
  }
  async discoverElectras(t) {
    try {
      return console.log("attempting device discovery with handshake"), await this.tryHandshakeDiscovery(t);
    } catch (s) {
      if (s instanceof U)
        return console.log(
          "old firmware detected, attempting discovery without handshake"
        ), await this.tryOldFirmwareDiscovery(t);
      throw s;
    }
  }
  async tryHandshakeDiscovery(t) {
    const s = this.getInputPorts(), r = this.getOutputPorts(), n = [], i = [], a = {}, o = {};
    let c = !1;
    const y = ({ portId: w, message: f }) => {
      f.type === "info" && (f.info.port === void 0 || f.info.reference === void 0 ? c = !0 : o[w] = f);
    };
    try {
      await Promise.allSettled([
        ...s.map(async ({ id: u }) => {
          await this.openInput(u, t), this.addInputMessageListener(u, y), n.push(u);
        }),
        ...r.map(async ({ id: u }) => {
          await this.openOutput(u, t), i.push(u);
        })
      ]);
      for (let u = 0; u < i.length; u++)
        a[i[u]] = u, await this.sendData(
          i[u],
          p(
            Uint8Array.from([
              h.FileRequest,
              l.ElectraInfo,
              u
            ])
          )
        );
      if (await new Promise((u) => setTimeout(u, t)), c)
        throw new U();
      const w = Object.entries(o), f = {};
      for (const [u, x] of Object.entries(a)) {
        const A = w.find(
          ([, I]) => I.info.reference === x
        );
        if (A !== void 0) {
          const [I, g] = A;
          f[g.info.serial] === void 0 && (f[g.info.serial] = {
            serial: g.info.serial,
            swVersion: g.info.versionText,
            hwRevision: Number.parseFloat(g.info.hwRevision),
            1: {
              input: null,
              output: null
            },
            2: {
              input: null,
              output: null
            },
            ctrl: {
              input: null,
              output: null
            }
          });
          const E = f[g.info.serial][Y(g.info.port)];
          E.input = I, E.output = u;
        }
      }
      return Object.values(f);
    } finally {
      console.log("trying to close"), await Promise.allSettled([
        ...n.map(async (w) => {
          this.removeInputMessageListener(w, y), await this.closeInput(w, t);
        }),
        ...i.map((w) => this.closeOutput(w, t))
      ]);
    }
  }
  static couldBeElectraPort(t) {
    return /Electra|MIDIIN[2-3]$/i.test(t);
  }
  async tryOldFirmwareDiscovery(t) {
    const s = this.getInputPorts().reduce(
      (o, c) => (d.couldBeElectraPort(c.name) && (o[c.id] = c), o),
      {}
    ), r = this.getOutputPorts().reduce(
      (o, c) => (d.couldBeElectraPort(c.name) && (o[c.id] = c), o),
      {}
    ), n = [], i = {};
    await Promise.allSettled(
      Object.values(s).map(async ({ id: o }) => {
        await this.openInput(o, t), n.push(o);
      })
    );
    for (const o of Object.values(r))
      try {
        await this.openOutput(o.id, t);
        const [c] = await Promise.all([
          this.waitForMessage(n, "info", t),
          this.sendData(
            o.id,
            p(
              Uint8Array.from([
                h.FileRequest,
                l.ElectraInfo
              ])
            )
          )
        ]);
        i[o.id] = c;
      } catch {
        console.log("something went wrong", o);
      } finally {
        await this.closeOutput(o.id, t);
      }
    await Promise.allSettled(
      n.map((o) => this.closeInput(o, t))
    );
    const a = {};
    for (const [o, c] of Object.entries(i)) {
      const y = r[o];
      a[c.info.serial] === void 0 && (a[c.info.serial] = {
        serial: c.info.serial,
        swVersion: c.info.versionText,
        hwRevision: Number.parseFloat(c.info.hwRevision),
        1: {
          input: null,
          output: null
        },
        2: {
          input: null,
          output: null
        },
        ctrl: {
          input: null,
          output: null
        }
      }), /CTRL|Port 3|MIDI 3|MIDIOUT3/i.test(y.name) ? a[c.info.serial].ctrl = {
        input: c.portId,
        output: o
      } : /Port 2|MIDI 2|MIDIOUT2/i.test(y.name) ? a[c.info.serial][2] = {
        input: c.portId,
        output: o
      } : /Controller|Port 1|MIDI 1|MIDIOUT1/i.test(y.name) && (a[c.info.serial][1] = {
        input: c.portId,
        output: o
      });
    }
    return Object.values(a);
  }
  waitForMessage(t, s, r, n) {
    let i;
    return F(
      new Promise((a) => {
        if (i = ({ portId: o, message: c }) => {
          c.type === s && a({
            ...c,
            portId: o
          });
        }, typeof t == "string")
          this.addInputMessageListener(t, i);
        else
          for (const o of t)
            this.addInputMessageListener(o, i);
      }),
      r,
      n,
      () => {
        if (i !== void 0)
          if (typeof t == "string")
            this.removeInputMessageListener(t, i);
          else
            for (const a of t)
              this.removeInputMessageListener(a, i);
      }
    );
  }
}
export {
  J as CommunicationContext,
  M as ELECTRA_MANUFACTURER_ID,
  d as ElectraMidiCommunication,
  k as SYSEX_FRAME_START,
  D as SYSEX_FRAME_STOP,
  _ as TimeoutError,
  Z as clearSlotForElectra,
  b as executeLuaForElectra,
  G as getPresetForElectra,
  K as getPresetListForElectra,
  V as getSysexDataForElectra,
  $ as isSysExMessage,
  H as isSysexForElectra,
  T as isValidPort,
  v as makeCommunicationPorts,
  p as makeSysexForElectra,
  Y as parsePort,
  L as stringToUint8Array,
  Q as switchToSlotForElectra,
  C as updateLogConfigForElectra,
  z as uploadConfigForElectra,
  X as uploadLuaForElectra,
  W as uploadPresetForElectra,
  se as useCommunicationContext,
  F as withTimeout
};
//# sourceMappingURL=index.js.map
